var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottleIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 743,
    viewBox: "0 0 481 743",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_83_33233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334.435,
    cy: -4.96355,
    r: 66.2845,
    fill: "#0094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.668 145.633V127.605H280.202V145.633H268.151V187.697H280.202V413.041C260.116 430.067 215.123 473.133 195.84 509.188V1197.24C196.845 1201.24 200.661 1209.86 207.892 1212.26H460.978C468.209 1209.86 472.026 1201.24 473.03 1197.24V509.188C453.747 473.133 408.754 430.067 388.668 413.041V187.697H400.72V145.633H388.668Z",
    fill: "url(#paint0_linear_83_33233)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.434,
    cy: 109.854,
    r: 301.293,
    transform: "rotate(0.0569805 334.434 109.854)",
    stroke: "url(#paint1_linear_83_33233)",
    strokeWidth: 60.2586
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_33233",
    x1: 334.435,
    y1: 1073.67,
    x2: 334.435,
    y2: 440.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_33233",
    x1: 334.282,
    y1: -37.7798,
    x2: 334.758,
    y2: 441.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0094FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_33233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 668,
    height: 1539.92,
    fill: "white",
    transform: "translate(0 -347.148)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottleIllustration);
export default __webpack_public_path__ + "static/media/bottle-illustration.00842fcd486cc000268107ed7174500f.svg";
export { ForwardRef as ReactComponent };